import { render } from "./showresult.vue?vue&type=template&id=040183de&scoped=true"
import script from "./showresult.vue?vue&type=script&lang=js"
export * from "./showresult.vue?vue&type=script&lang=js"

import "./showresult.vue?vue&type=style&index=0&id=040183de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040183de"]])

export default __exports__